import React from "react";
import Breadcrumbs from "features/shared/components/breadcrumbs/Breadcrumbs";
import styles from "./header.module.scss";
import BreadcrumbLink from "features/shared/components/breadcrumbs/BreadcrumbLink";

interface Props {
  title: string;
  subtitle?: string;
  includeBreadcrumbs?: boolean;
  links?: BreadcrumbLink[];
  titleAsBreadcrumbLink?: boolean;
  className?: string;
}

const Header = ({ title, subtitle, includeBreadcrumbs, links, titleAsBreadcrumbLink = true, className }: Props) => {
  // sub-renders
  const renderBreadcrumbs = () => {
    if (includeBreadcrumbs) {
      const activeLink: BreadcrumbLink = { text: title };
      let extendedLinks: BreadcrumbLink[] = links ? [...links] : [];

      if (titleAsBreadcrumbLink) {
        extendedLinks.push(activeLink);
      }

      return (
        <Breadcrumbs
          includeHomeLink
          onMobileOnlyBackLink
          contentType="links"
          links={extendedLinks}
          className="my-1"
        />
      );
    }
  };

  // render
  return (
    <section className={`${styles.header}${className ? ` ${className}` : ""}`}>
      <h1 className={`${styles.headerTitle}${includeBreadcrumbs ? " mr-4" : ""}`}>
        <span className="mr-2">{title}</span>
        {subtitle && (
          <small className={styles.headerSubtitle}>{subtitle}</small>
        )}
      </h1>
      {renderBreadcrumbs()}
    </section>
  );
};

export default Header;
